import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { campsenum } from '../../../../../../../../models/enums.generated';
import { CampsEnumTranslationService } from '../../../../../../../../services/camps-enum-translation.service';
import { CampsDetailsFormStateService } from '../../../../../camp-details-form-state-service';

@Component({
    selector: 'app-option-details',
    templateUrl: './option-details.component.html',
    styleUrls: ['./option-details.component.scss'],
    standalone: false
})
export class OptionDetailsComponent implements OnInit {
  
    @Input() public form : UntypedFormGroup;

    @Output() removed: EventEmitter<UntypedFormGroup> = new EventEmitter();

    constructor(public state : CampsDetailsFormStateService, private enumTranslation : CampsEnumTranslationService) { 

    }

    ngOnInit(): void {
     
    }

    public get isOtherItemEdited(){
        return this.state.isOtherItemEdited(this.form);
    }


    public edit(){
        this.state.markAsEdited(this.form);
    }

    public remove(){
         this.removed.emit(this.form)
    }

    public translateType(type: campsenum.OptionType) {
        return this.enumTranslation.optionType(type);
    }

}
